import styled from '@emotion/styled'
import { useEventListener } from '@mantine/hooks'
import { FC, PropsWithChildren, ReactNode, useState } from 'react'
import { PopoverAlign, PopoverPosition, Popover as ReactTinyPopover } from 'react-tiny-popover'
import { Fonts } from '~/assets/style/fonts'
import { ElevationLevelValues } from '~/assets/style/tokens'
import { WithClassName } from '~/types/utils'

export type TooltipProps = WithClassName & {
  title: ReactNode
  align?: PopoverAlign
  positions?: PopoverPosition[]
  reposition?: boolean
  offset?: number
  open?: boolean
  disabled?: boolean
  containerStyle?: Partial<CSSStyleDeclaration>
}

const TooltipContent = styled.div`
  background: #4c5774;
  color: #fff;
  padding: 10px;
  border-radius: 4px;
  ${Fonts.P2}
  max-width: 500px;
`

const TooltipTrigger = styled.div`
  display: inline;
`

const BaseTooltip: FC<PropsWithChildren<TooltipProps>> = ({ className, children, title, align, positions, reposition, offset = 0, open, disabled, containerStyle }) => {
  const [key, setKey] = useState('')
  const [internalOpen, setInternalOpen] = useState(open || false)
  const [previousOpen, setPreviousOpen] = useState(open)

  // `open` drives the tooltip from the parent: realign on change, during render rather than in an effect
  if (previousOpen !== open) {
    setPreviousOpen(open)
    setInternalOpen(open || false)
  }

  const manual = open !== undefined

  const randomKey = () => {
    setKey(`${Math.random()}`)
  }
  useEventListener('resize', randomKey)

  return (
    <ReactTinyPopover
      containerStyle={{ zIndex: `${ElevationLevelValues.high}`, ...containerStyle }}
      isOpen={internalOpen}
      content={<TooltipContent>{title}</TooltipContent>}
      reposition={reposition ?? false}
      positions={positions || ['top', 'bottom', 'left', 'right']}
      onClickOutside={() => setInternalOpen(false)}
      align={align ?? 'center'}
      padding={offset}
      key={key}
    >
      <TooltipTrigger className={className} onMouseLeave={() => !manual && setInternalOpen(false)} onMouseEnter={() => !disabled && setInternalOpen(true)}>
        {children}
      </TooltipTrigger>
    </ReactTinyPopover>
  )
}

export const Tooltip = styled(BaseTooltip)``
